'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMessageURL = exports.getMessageFilter = undefined;

var _stringUtil = require('../../../../../../common/utils/stringUtil');

var _notificationConstants = require('../../../../../../common/notifications/notificationConstants');

var getModifiedFilters = function getModifiedFilters(modifiedChildren) {
    var modifiedAfter = modifiedChildren.map(function (child) {
        return child.get('modifiedTime');
    }).reduce(function (modifiedTime, childModified) {
        return Math.min(modifiedTime, childModified);
    }, Infinity);

    var modifiedBy = modifiedChildren.map(function (child) {
        return child.get('modifiedBy');
    }).filter(function (modifiedUser, i, list) {
        return list.indexOf(modifiedUser) === i;
    }).toArray();

    return {
        filter_after: modifiedAfter,
        filter_user: modifiedBy
    };
};

var getMessageFilter = exports.getMessageFilter = function getMessageFilter(message) {
    if (message.get('message') === _notificationConstants.MODIFIED_ELEMENTS_BOARD_MESSAGES.INVITED) {
        return null;
    }

    return getModifiedFilters(message.get('children'));
};

var getMessageURL = exports.getMessageURL = function getMessageURL(message) {
    return '/' + message.get('id') + '?' + (0, _stringUtil.createQueryString)(getMessageFilter(message));
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/notifications/modifiedBoard/modifiedBoardUtil.js
// module id = 2189
// module chunks = 0